export default {
  API_URL: "https://scaleapi.designori.net",
  CourseId: '1'
};
